import { gql } from '@apollo/client'

export const PAYOUTS_QUERY = gql`
  query payouts($sortBy: PayoutSort, $filter: PayoutFilter, $page: Int, $limit: Int) {
    payouts(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        status
        amount
        payoutStatus
        payoutRequestedAt
        payoutProcessedAt
        stripePayoutId
        payments {
          id
          amountDecimal
          refundAmountDecimal
          transactionFee
          total
          processing {
            id
            m2Case {
              id
            }
          }
        }
      }
    }
  }
`
